import React, { useRef, useEffect } from 'react';
import './PlaceDropdown.css';

export interface PlaceDropdownProps {
  isOpen: boolean;
  selectedPlace?: string;
  onPlaceChange: (place: string | undefined) => void;
  onClose: () => void;
  isDisabled?: boolean;
}

const PlaceDropdown: React.FC<PlaceDropdownProps> = ({
  isOpen,
  selectedPlace,
  onPlaceChange,
  onClose,
  isDisabled = false,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  const places = [
    { id: undefined, label: 'Beyaz Arka Plan', icon: '✨' },
    { id: 'work', label: 'İş', icon: '💼' },
    { id: 'street', label: 'Sokak', icon: '🚶' },
    { id: 'event', label: 'Etkinlik', icon: '🎉' },
  ];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handlePlaceClick = (placeId: string | undefined) => {
    if (!isDisabled) {
      onPlaceChange(placeId);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="place-dropdown-content" ref={dropdownRef}>
      <div className="place-dropdown-items">
        {places.map((place) => (
          <button
            key={place.id || 'default'}
            className={`place-dropdown-item ${
              selectedPlace === place.id ? 'place-dropdown-item--active' : ''
            } ${isDisabled ? 'place-dropdown-item--disabled' : ''}`}
            onClick={() => handlePlaceClick(place.id)}
            disabled={isDisabled}
            title={place.label}
          >
            <span className="place-dropdown-item-icon">{place.icon}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PlaceDropdown;

